import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCustomization from './customization.reducer';

export const selectCustomizationState = createFeatureSelector<fromCustomization.State>(fromCustomization.customizationFeatureKey);

export const selectCustomization = createSelector(selectCustomizationState, (state) => state.customization);
